import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class KsefDocumentWithPastIssueDateWillBeOfflineWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.ksef-document.will-be-ofline-with-past-issue-date');
    }
}
